import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { object, string } from "yup";
import AddTagFormDialog from "./AddTagFormDialog";
import { useAddTagsMutation } from "src/services/TagServices";
import { showToast } from "src/utils/showToaster";

export type AddTagFormDialogValues = {
  tagName: string;
};

type Props = {
  onClose: () => void;
};

const AddTagFormDialogWrapper = ({ onClose }: Props) => {
  const [saveNextChecked, setSaveNextChecked] = useState(true);

  const [addTag] = useAddTagsMutation();

  // Form Initial Values
  const initialValues: AddTagFormDialogValues = {
    tagName: " ",
  };

  // Validation Schema
  const validationSchema = object().shape({
    tagName: string().required("Please enter tagName"),
  });

  // Handle Submit
  const handleSubmit = (
    values: AddTagFormDialogValues,
    { setSubmitting, resetForm }: FormikHelpers<AddTagFormDialogValues>
  ) => {
    addTag(values).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          if (!saveNextChecked) {
            resetForm();
            onClose();
          }
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Dialog open maxWidth="xs" fullWidth>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            <AddTagFormDialog
              formikProps={formikProps}
              onClose={onClose}
              setSaveNextChecked={setSaveNextChecked}
              saveNextChecked={saveNextChecked}
            />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default AddTagFormDialogWrapper;
